<template>
  <div class="row">
    <div class="col-md-6">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <img :src="product.bild_url" alt="Produktbild" style="width: 165px; height: auto;">
      </a>
    </div>
    <div class="col-md-6 d-flex flex-column align-items-center justify-content-center">
      <a :href="product.amazon_url" rel="sponsored nofollow noopener" target="_blank">
        <button class="btn14 px-1 py-1">Auf Amazon ansehen*</button>
      </a>
    </div>
  </div>
  <div class="product-tabs mt-2">
    <input :id="'tab1-' + product.id" type="radio" :name="'tabs-' + product.id" checked="checked" />
    <input :id="'tab2-' + product.id" type="radio" :name="'tabs-' + product.id" />
    <input :id="'tab3-' + product.id" type="radio" :name="'tabs-' + product.id" />

    <ul class="tabs">
      <li class="tab"> <label :for="'tab1-' + product.id">Allgemeines</label> </li>
      <li class="tab"><label :for="'tab2-' + product.id">Wischfuktionen</label> </li>
      <li class="tab"><label :for="'tab3-' + product.id">App & Navigation</label> </li>
    </ul>


    <div class="tab-content">
      <div class="display-properties">
        <div class="property">
          <label>Erscheinungsdatum</label>
          <span>{{ product.release_date || 'Keine Angabe' }}</span>
        </div>

        <div class="property">
          <label>Saugleistung</label>
          <span>{{ product.saugleistung_pa || 'Keine Angabe' }} Pa</span>
        </div>

        <div class="property">
          <label>Maße (L/B/H)</label>
          <span>{{ product.laenge_cm || 'kA' }} x {{ product.breite_cm || 'kA' }} x {{ product.hoehe_cm || 'kA' }} cm</span>
        </div>

        <div class="property">
          <label>Gewicht</label>
          <span v-if="product.gewicht_kg">{{ product.gewicht_kg }} kg</span>
          <span v-else>Keine Angabe</span>
        </div>

        <div class="property">
          <label>Staubbehälter</label>
          <span>{{ product.staubbehaelter_ml || '-' }} ml</span>
        </div>

        <div class="property">
          <label>Wassertank</label>
          <span>{{ product.wassertank_ml || '-' }} ml</span>
        </div>

        <div class="property">
          <label>Lautstärke</label>
          <span v-if="product.lautstaerke_db">{{ product.lautstärke_dB }} dB</span>
          <span v-else>Keine Angabe</span>
        </div>

        <div class="property">
          <label>Akkukapazität</label>
          <span>{{ product.akkukapazitaet_mAh || '-' }} mAh</span>
        </div>

        <div class="property">
          <label>Max. Ladedauer</label>
          <span>{{ product.max_ladedauer_min || '-' }} min</span>
        </div>

        <div class="property">
          <label>Max. Saugdauer</label>
          <span>{{ product.max_saugdauer_min || '-' }} min</span>
        </div>

      </div>

    </div>
    <div class="tab-content">
      <div class="display-properties">
        <div class="property">
          <label>Wischfunktion</label>
          <span v-if="product.hat_wischfunktion == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Aktive Wasserzufuhr</label>
          <span v-if="product.wischer_aktive_wasserzufuhr == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Rotierender Wischmopp</label>
          <span v-if="product.wischer_rotierend == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Vibrierender Wischmopp</label>
          <span v-if="product.wischer_vibrierend == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Erkennt Teppiche</label>
          <span v-if="product.wischer_erkennt_teppiche == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Anhebbar auf Teppich</label>
          <span v-if="product.wischer_anhebbar_teppich == 1">Ja</span>
          <span v-else>Nein</span>
        </div>
        <div class="property">
          <label>Hat Reinigungsstation</label>
          <span v-if="product.hat_reinigungsstation == 1">Ja</span>
          <span v-else>Nein</span>
        </div>
        <div class="property">
          <label>Absaugstation</label>
          <span v-if="product.station_absaugstation == 1">Ja</span>
          <span v-else>Nein</span>
        </div>
        
      </div>
    </div>
    <div class="tab-content">
      <div class="display-properties">
          <div class="property">
          <label>ToF Navigation</label>
          <span v-if="product.navigation_tof == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>LDS Navigation</label>
          <span v-if="product.navigation_lds == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Kamerazugriff</label>
          <span v-if="product.app_kamerazugriff == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Mehrere Karten</label>
          <span v-if="product.app_mehrere_karten == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Virtuelle Grenzen</label>
          <span v-if="product.app_virtuelle_grenzen == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>Virtuelle Raumeinteilung</label>
          <span v-if="product.app_virtuelle_raumeinteilung == 1">Ja</span>
          <span v-else>Nein</span>
        </div>

        <div class="property">
          <label>3D-Karte</label>
          <span v-if="product.app_3D_karte == 1">Ja</span>
          <span v-else>Nein</span>
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import StarRating from "./StarRating.vue";

export default {
  components: {
    StarRating
  },
  props: ['product'],

  computed: {

    hdmiCount() {
      return Object.values(this.product).reduce((total, value) => total + (value > 0 ? 1 : 0), 0);
    },
    hdmiString() {
      let hdmiList = [];
      if (this.product.hdmi_1_4 > 0) hdmiList.push(`${this.product.hdmi_1_4} x HDMI 1.4`);
      if (this.product.hdmi_2_0 > 0) hdmiList.push(`${this.product.hdmi_2_0} x HDMI 2.0`);
      if (this.product.hdmi_2_1 > 0) hdmiList.push(`${this.product.hdmi_2_1} x HDMI 2.1`);
      else { return "Keine Information" };
      return hdmiList.join('\n');
    },

    usbCount() {
      return Object.values(this.product).reduce((total, value) => total + (value > 0 ? 1 : 0), 0);
    },
    usbString() {
      const usbVersions = {
        usb_2_0: "USB 2.0",
        usb_3_0: "USB 3.0"
      };
      const activeUSBVersions = Object.keys(usbVersions).filter(key => this.product[key] > 0);
      return activeUSBVersions.length > 0 ? activeUSBVersions.map(version => `${this.product[version]} x ${usbVersions[version]}`).join(', ') : "Nicht vorhanden";
    },
    hasHDR() {
      return Object.values(this.product).some(value => value === "1");
    },
    hdrString() {
      const hdrVersions = {
        HLG: "HLG",
        HDR10: "HDR10",
        HDR10Plus: "HDR10Plus",
        HDRQuantum: "HDRQuantum",
        DolbyVision: "Dolby Vision",
        DolbyVisioniq: "Dolby Vision IQ"
      };
      const activeHDRVersions = Object.keys(hdrVersions).filter(key => this.product[key] === "1");
      return activeHDRVersions.length > 0 ? activeHDRVersions.map(version => hdrVersions[version]).join(", ") : "Keine Information";
    }



  },



  mounted() {
  },

};
</script>

<style scoped>
.datasheet-btn {
  background-color: #e6e0d980;
  /* Grün */
  border: none;
  color: rgb(98, 94, 94);
  padding: 10px 20px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 15px;
  margin: 4px 2px;
  transition-duration: 0.4s;
  cursor: pointer;
}

.custom-btn:hover {
  background-color: white;
  color: black;
  border: 2px solid #4CAF50;
}


.datasheet-table th {
  background-color: #e9d9c7;
  color: #0e0808;
  text-align: left;

}

.datasheet-table td,
.datasheet-table th {
  text-align: left;
  font-size: 14px;
}

.datasheet-table label {
  font-weight: bold;
}

.product-tabs {
  overflow-x: hidden;
  border-bottom: 1px solid #ccc;
}

.product-tabs [type="radio"] {
  display: none;
}

.tabs {
  display: flex;
  align-items: stretch;
  list-style: none;
  padding: 0px;
  border-bottom: 1px solid #ccc;
  margin: 0px;
}

.tab>label {
  display: block;
  margin-bottom: -1px;

  border: 1px solid #ccc;
  background: #eee;
  color: #666;
  font-size: 15px;
  font-weight: 600;


  cursor: pointer;
  transition: all 0.3s;
  padding: 2px;
}

.tab:hover label {
  border-top-color: #333;
  color: #333;
}

.tab-content {
  display: none;
  color: #777;
}

.product-tabs [type="radio"]:nth-of-type(1):checked~.tabs .tab:nth-of-type(1) label,
.product-tabs [type="radio"]:nth-of-type(2):checked~.tabs .tab:nth-of-type(2) label,
.product-tabs [type="radio"]:nth-of-type(3):checked~.tabs .tab:nth-of-type(3) label,
.product-tabs [type="radio"]:nth-of-type(4):checked~.tabs .tab:nth-of-type(4) label {
  border-bottom-color: #fff;
  border-top-color: #B721FF;
  background: #fff;
  color: #222;
}

.product-tabs [type="radio"]:nth-of-type(1):checked~.tab-content:nth-of-type(1),
.product-tabs [type="radio"]:nth-of-type(2):checked~.tab-content:nth-of-type(2),
.product-tabs [type="radio"]:nth-of-type(3):checked~.tab-content:nth-of-type(3),
.product-tabs [type="radio"]:nth-of-type(4):checked~.tab-content:nth-of-type(4) {
  display: block;
}

.custom-modal-body {
  padding: 0;
}

.display-properties {
  margin: 5px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.property {

  font-size: 15px;
}

label {
  font-weight: bold;
  display: block;
  font-size: 14px;
}

.mt-small-device {
  margin-top: 0;
}

@media (max-width: 576px) {
  .mt-small-device {
    margin-top: 5px;
  }
}

.btn14 {
  background-color: #fa890052;
  border: 1px solid #222222 !important;
  width: 70%;
  line-height: 1.3;
}
</style>